import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import LocationsActive from '../contentPages/LocationsActive'

const ArchiveLibrary_Locations_Archived = () => {
	const { id } = useParams()
	const userLogin = useSelector(state => state.userLogin)
	const { userInfo } = userLogin

	const { location, loading } = useSelector(state => {
		return {
			loading: state.locations.isLoading,
			success: state.locations.isInitialized,
			location: state.locations.entities[id],
		}
	})

	// TODO: Create skeleton loader
	if (loading) return null

	return <LocationsActive userId={userInfo._id} location={location} />
}

export default ArchiveLibrary_Locations_Archived
